/** Интерактивные HTML-виджеты на доске. */
const WIDGET_CHROME_SELECTOR =
  ".wb-calc-card, .wb-timer-card, .wb-code-card, .wb-audio-card, .wb-pdf-nav, .wb-pdf-thumbs";

/** Панели редактора поверх холста — клики не должны уходить на select/pen/shape. */
const EDITOR_CHROME_SELECTOR = [
  ".wb-selection-toolbar",
  ".wb-tool-options-popover",
  ".wb-floating-tools",
  ".wb-floating-toolbar",
  ".wb-board-floating-toolbar",
  ".wb-tool-rail",
  ".wb-zoom-controls",
  ".wb-minimap",
  ".wb-board-frames-panel",
  ".wb-board-frame-present-bar",
  WIDGET_CHROME_SELECTOR,
].join(", ");

export function isBoardEditorChrome(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(EDITOR_CHROME_SELECTOR));
}

export function isCalculatorPlotTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(".wb-calc-card__plot"));
}

/** Любой виджет, включая весь калькулятор (для фигур/текста и т.п.). */
export function isBoardWidgetChrome(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(WIDGET_CHROME_SELECTOR));
}

/**
 * Виджеты, но область графика калькулятора свободна —
 * перо рисует поверх, ластик стирает только линии.
 */
export function isBoardWidgetChromeExceptCalcPlot(target: EventTarget | null): boolean {
  if (isCalculatorPlotTarget(target)) return false;
  return isBoardWidgetChrome(target);
}

/** Клавиатура/вкладки калькулятора — штрих пера здесь обрываем. */
export function isCalculatorKeypadAt(clientX: number, clientY: number): boolean {
  const els =
    typeof document.elementsFromPoint === "function"
      ? document.elementsFromPoint(clientX, clientY)
      : [document.elementFromPoint(clientX, clientY)];
  for (const el of els) {
    if (!(el instanceof Element)) continue;
    if (
      el.closest(
        ".wb-path-preview, .wb-shape-preview, .wb-frame-preview, .wb-selection-frame, .wb-zoom-controls, .wb-tool-rail"
      )
    ) {
      continue;
    }
    if (el.closest(".wb-calc-card__plot")) return false;
    if (el.closest(".wb-calc-card")) return true;
    return false;
  }
  return false;
}
